export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main ?? '#5B35A5';

  return {
    headerCard: {
      display: 'flex',
      flexDirection: 'column',
      width: { xs: '100%', lg: '792px' },
      maxWidth: { xs: '100%', md: '792px' },
      p: { xs: '16px', md: '1.5rem 1rem' },
      borderRadius: '0.5rem',
      border: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      bgcolor: isDark ? '#3A3444' : '#FFFFFF',
      boxSizing: 'border-box',
    },
    title: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: isDark ? '#FFFFFF' : '#000000DE',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    description: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '150%',
      letterSpacing: '0.15px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
      mt: '4px',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    materialTab: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: '8px',
      px: '12px',
      py: '6px',
      mt: '1rem',
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      border: `1px solid ${isDark ? '#D0BCFA80' : '#45218880'}`,
      borderRadius: '1.5rem',
      color: primary,
      fontSize: '0.8125rem',
      fontWeight: 500,
      width: 'fit-content',
      lineHeight: '22px',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    materialTabIcon: {
      height: '18px',
      width: '18px',
      color: primary,
      flexShrink: 0,
    },
    materialTabText: {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    materialTabArrow: {
      fontSize: '12px',
      color: primary,
      flexShrink: 0,
    },
    metadataRow: {
      display: 'grid',
      mt: '1.5rem',
      gridTemplateColumns: {
        xs: '1fr 1fr',
        sm: 'repeat(2, minmax(0, 1fr))',
        lg: 'repeat(4, minmax(0, 1fr))',
      },
      gap: { xs: '1rem', md: '1.5rem' },
      width: '100%',
    },
    metadataItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '10px',
      minWidth: 0,
    },
    metadataIcon: {
      fontSize: '24px',
      color: primary,
      flexShrink: 0,
      mt: '2px',
    },
    metadataLabel: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '157%',
      letterSpacing: '0.1px',
      color: isDark ? '#FFFFFFDE' : '#000000DE',
    },
    metadataValue: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.17px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
    },
    divider: {
      borderColor: isDark ? '#F8F7F929' : '#231F2929',
      my: '1.25rem',
    },
    actionsRowMobile: {
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
      },
      width: '100%',
      gap: { xs: '0.75rem', sm: '1.5rem' },
      '& .full-width': {
        /* Forces to cover the entire row */
        mt: { xs: 0, sm: '-0.5rem' },
        gridColumn: '1/-1',
      },
    },
    actionsRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: '1rem',
    },
    providerButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      maxHeight: '36px',
    },
    purpleButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      maxHeight: '36px',
      color: primary,
      borderColor: isDark ? '#D0BCFA80' : '#45218880',
      '&:hover': {
        borderColor: primary,
        backgroundColor: isDark ? '#D0BCFA1A' : '#5B35A50A',
      },
      '&.Mui-disabled': {
        pointerEvents: 'auto',
        '&:hover': {
          border: '1px solid rgba(0, 0, 0, 0.12)',
        },
      },
    },
    providerLogo: {
      width: 20,
      height: 20,
      flexShrink: 0,
    },
  };
};
